export const VUETIFY_DEFAULTS_KEY = Symbol.for("vuetify:defaults");

export const PIP_ROOT_CLASS = "pip-root";
